<template>
  <span>
    <div v-if="openPopperID != cellData[1]" @click="openPopper(cellData[1])">
      <slot></slot>
    </div>
    <vue-popper
      v-if="openPopperID == cellData[1]"
      :ref="'popper' + cellData[1]"
      trigger="click"
      :boundaries-selector="'#game-' + gameId"
      :options="popperOptions"
      :force-show="true"
      @documentClick="closePopper(cellData[1])"
      @hide="popperHide(cellData[1])"
    >
      <div class="popper history-popper">
        <!-- Header Start -->
        <div class="history-popper-header">
          <Row type="flex" justify="space-between">
            <Col>
              <Row type="flex">
                <b class="history-title">{{ gameTitle }}</b>
              </Row>
              <Row>
                <div class="history-draw-no">
                  {{ $t("general.draw_no") }}{{ gameCode }}{{ cellData[1] }}
                </div>
              </Row>
               
            </Col>
            <Col>
              <Row
                class="history-popper-header-close"
                type="flex"
                justify="center"
                align="middle"
              >
                <Icon
                  type="md-close"
                  size="24"
                  @click="closePopper(cellData[1])"
                />
              </Row>
            </Col>
          </Row>
        </div>
        <!-- End of Header -->
        <!-- Content start -->
        <div class="history-popper-content">
          <Row justify="center" type="flex">

            
            <Col span="12" class="history-fan" :class="cellData[3]">
              <div>{{$t("fantan.fan")}}{{cellData[3]}}</div>
            </Col>
            <Col span="12" class="history-oe">
              <div v-if="cellData[4] == 1">{{ $t("fantan.odd") }}</div>
              <div v-else>{{ $t("fantan.even") }}</div>
            </Col>
          </Row>
          <Row justify="center" type="flex">
            <Col v-if="cellData[5] == 1" span="8" class="history-ssh">
              <div>{{ $t("fantan.ssh") }}123</div>
            </Col>
            <Col v-if="cellData[6] == 1" span="8" class="history-ssh">
              <div>{{ $t("fantan.ssh") }}234</div>
            </Col>
            <Col v-if="cellData[7] == 1" span="8" class="history-ssh">
              <div>{{ $t("fantan.ssh") }}241</div>
            </Col>
            <Col v-if="cellData[8] == 1" span="8" class="history-ssh">
              <div>{{ $t("fantan.ssh") }}341</div>
            </Col>
          </Row>
          <Row justify="center" type="flex">
            <Col v-if="cellData[9] == 1" span="12" class="history-kwok">
              <div>{{ $t("fantan.kwok") }}12</div>
            </Col>
            <Col v-if="cellData[10] == 1" span="12" class="history-kwok">
              <div>{{ $t("fantan.kwok") }}14</div>
            </Col>
            <Col v-if="cellData[11] == 1" span="12" class="history-kwok">
              <div>{{ $t("fantan.kwok") }}23</div>
            </Col>
            <Col v-if="cellData[12] == 1" span="12" class="history-kwok">
              <div>{{ $t("fantan.kwok") }}34</div>
            </Col>
          </Row>
          <Row justify="center" type="flex">
            <Col v-if="cellData[13] == 1" span="8" class="history-nim">
              <div>1{{ $t("fantan.nim") }}2</div>
            </Col>
            <Col v-if="cellData[14] == 1" span="8" class="history-nim">
              <div>1{{ $t("fantan.nim") }}3</div>
            </Col>
            <Col v-if="cellData[15] == 1" span="8" class="history-nim">
              <div>1{{ $t("fantan.nim") }}4</div>
            </Col>
            <Col v-if="cellData[16] == 1" span="8" class="history-nim">
              <div>2{{ $t("fantan.nim") }}1</div>
            </Col>
            <Col v-if="cellData[17] == 1" span="8" class="history-nim">
              <div>2{{ $t("fantan.nim") }}3</div>
            </Col>
            <Col v-if="cellData[18] == 1" span="8" class="history-nim">
              <div>2{{ $t("fantan.nim") }}4</div>
            </Col>
            <Col v-if="cellData[19] == 1" span="8" class="history-nim">
              <div>3{{ $t("fantan.nim") }}1</div>
            </Col>
            <Col v-if="cellData[20] == 1" span="8" class="history-nim">
              <div>3{{ $t("fantan.nim") }}2</div>
            </Col>
            <Col v-if="cellData[21] == 1" span="8" class="history-nim">
              <div>3{{ $t("fantan.nim") }}4</div>
            </Col>
            <Col v-if="cellData[22] == 1" span="8" class="history-nim">
              <div>4{{ $t("fantan.nim") }}1</div>
            </Col>
            <Col v-if="cellData[23] == 1" span="8" class="history-nim">
              <div>4{{ $t("fantan.nim") }}2</div>
            </Col>
            <Col v-if="cellData[24] == 1" span="8" class="history-nim">
              <div>4{{ $t("fantan.nim") }}3</div>
            </Col>
          </Row>
          <Row justify="center" type="flex">
            <Col v-if="cellData[25] == 1" span="8" class="history-nga">
              <div>23{{ $t("fantan.nga") }}1</div>
            </Col>
            <Col v-if="cellData[26] == 1" span="8" class="history-nga">
              <div>24{{ $t("fantan.nga") }}1</div>
            </Col>
            <Col v-if="cellData[27] == 1" span="8" class="history-nga">
              <div>34{{ $t("fantan.nga") }}1</div>
            </Col>
            <Col v-if="cellData[28] == 1" span="8" class="history-nga">
              <div>13{{ $t("fantan.nga") }}2</div>
            </Col>
            <Col v-if="cellData[29] == 1" span="8" class="history-nga">
              <div>14{{ $t("fantan.nga") }}2</div>
            </Col>
            <Col v-if="cellData[30] == 1" span="8" class="history-nga">
              <div>34{{ $t("fantan.nga") }}2</div>
            </Col>
            <Col v-if="cellData[31] == 1" span="8" class="history-nga">
              <div>12{{ $t("fantan.nga") }}3</div>
            </Col>
            <Col v-if="cellData[32] == 1" span="8" class="history-nga">
              <div>14{{ $t("fantan.nga") }}3</div>
            </Col>
            <Col v-if="cellData[33] == 1" span="8" class="history-nga">
              <div>24{{ $t("fantan.nga") }}3</div>
            </Col>
            <Col v-if="cellData[34] == 1" span="8" class="history-nga">
              <div>12{{ $t("fantan.nga") }}4</div>
            </Col>
            <Col v-if="cellData[35] == 1" span="8" class="history-nga">
              <div>13{{ $t("fantan.nga") }}4</div>
            </Col>
            <Col v-if="cellData[36] == 1" span="8" class="history-nga">
              <div>23{{ $t("fantan.nga") }}4</div>
            </Col>
          </Row>

          <Row
                  class="history-summary-result-time"
                  type="flex"
                  justify="center"
                >{{ cellData[2] }}</Row>
        </div>

        
        <!-- Content ends -->
      </div>
      <div slot="reference" @click="closePopper(cellData[1])">
        <slot></slot>
      </div>
    </vue-popper>
  </span>
</template>

<script>
import VuePopper from "vue-popperjs";
import { Row, Col, Button, Message, Divider, Icon } from "iview";
import { titleCase, snakeCase } from "change-case";
import "vue-popperjs/dist/vue-popper.css";

export default {
  props: ["game", "cellData", "gameCode", "popperId", "gameId", "tableName"],
  components: {
    VuePopper,
    Row,
    Col,
    Icon,
  },
  data() {
    return {
      popperOptions: {
        placement: "bottom",
        hide: true,
        modifiers: {
          flip: { behavior: ["bottom"] },
          preventOverflow: { priority: ["left", "right"] },
        },
        removeOnDestroy: true,
      },
      openPopperID: "",
    };
  },
  computed: {
    gameTitle() {
      return titleCase(this.tableName);
    },
    gameSnakeCase() {
      return snakeCase(this.game);
    },
  },
  methods: {
    openPopper: function openPopper(a) {
      let vm = this;
      setTimeout(function () {
        vm.openPopperID = a;
      }, 30);
    },
    closePopper: function closePopper(a) {
      this.$refs["popper" + a].doClose();
    },
    popperHide: function popperHide(a) {
      this.$refs["popper" + a].doDestroy(),
        this.openPopperID === a && (this.openPopperID = "");
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.popper {
  cursor: default;
}

.history-popper-header-close {
  cursor: pointer;
}

.history-popper-header {
  padding: 13px 15px;
  opacity: 0.9;
  font-size: 12px;
  padding-bottom: 0px;
}
.history-title {
  text-transform: uppercase;
  color: $hilo-trend-lot-color-1;
  font-size: 14px;
}

.history-draw-no {
  color: white;
  display: block;
  font-size: 12px;
}
.history-total-result {
  color: white;
  margin: 2px;
  padding: 2px;
  font-size: 16px;
}

.history-small-title {
  color: white;
}

.history-popper-content {
  padding: 10px;
  padding-top: 2px;
}

.history-fan,
.history-oe,
.history-ssh,
.history-kwok,
.history-nim,
.history-nga {
  padding: 4px;
  text-align: center;
  font-size: 12px;
  background: rgb(0, 0, 0, 0.25);
  border: 0.5px solid rgba(255, 255, 255, 0.25);
  border-radius: 8px;
  margin: 5px 2px;
  overflow: hidden;
}

.history-fan.\31 {
  color: #c9c9c9;
}

.history-fan.\32 {
  color: #16cc86;
}

.history-fan.\33 {
  color: #f9cb62;
}

.history-fan.\34 {
  color: #fa4358;
}

.history-oe {
  color: #f27728;
}

.history-ssh,
.history-nim,
.history-nga {
  width: 31.5%;
}

.history-fan,
.history-oe,
.history-kwok {
  width: 48%;
}

.history-summary-cards.ivu-col {
  flex: 1;
}

.history-summary.ivu-row-flex {
  margin: 10px;
}

.history-summary-cards-container {
  height: 100%;
  padding: 4px 8px;
}

.summary-cards-first {
  margin-left: 15px;
}

.summary-cards-second {
  margin-left: -40px;
  margin-top: 15px;
}

.current-card {
  background: black;
  border-radius: 10%;
}

.previous-card {
  background: black;
  border-radius: 10%;
  opacity: 0.7;
}

.history-summary-result-time {
  font-size: 12px;
  margin-top: 5px;
}

.history-summary-hi-lo {
  width: 100%;
  border-radius: 8px;
  padding: 6px;
  margin: 4px 0;
  background-color: #f0f0f0;
  font-weight: bold;
  margin-top: 15px;
  color: black;
}

.history-summary-black-red {
  width: 100%;
  border-radius: 8px;
  padding: 6px;
  margin: 4px 0;
  background-color: #f0f0f0;
  font-weight: bold;
  color: $hilo-trend-lot-color-1;
}
.history-summary-black-red.R {
  color: red;
}
.history-summary-black-red.B {
  color: black;
}
.history-summary-black-red.J {
  color: $hilo-trend-lot-color-1;
}
</style>